import { render, staticRenderFns } from "./TopOperationDataTable.vue?vue&type=template&id=317e940e&scoped=true&"
import script from "./TopOperationDataTable.vue?vue&type=script&lang=js&"
export * from "./TopOperationDataTable.vue?vue&type=script&lang=js&"
import style0 from "./TopOperationDataTable.vue?vue&type=style&index=0&id=317e940e&scoped=true&lang=css&"
import style1 from "./TopOperationDataTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317e940e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataFooter } from 'vuetify/lib/components/VDataIterator';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataFooter,VDataTable})
